'use client';

import React, { Suspense } from 'react';
import classNames from 'classnames';
import { AD_RESERVED_CLASS } from '@benzinga/ads-utils';
import styles from './AdHeaderBanner.module.scss';

const FreestarAd = React.lazy(() =>
  import('@benzinga/ads/freestar').then(module => {
    return { default: module.FreestarAd };
  }),
);

interface AdHeaderBannerProps {
  ref?: React.Ref<HTMLDivElement>;
  headerType?: 'desktop' | 'mobile';
  loadAd?: boolean;
  expandedHeaderDisplayAd?: boolean;
}

export const AdHeaderBanner: React.FC<AdHeaderBannerProps> = React.forwardRef((props, ref) => {
  return (
    <div
      className={classNames(styles.container, 'ad-header-banner', AD_RESERVED_CLASS)}
      data-placement="top_header"
      ref={ref}
      style={{ '--desktop-header-height': props.expandedHeaderDisplayAd ? '260px' : '90px' } as React.CSSProperties}
    >
      {props.loadAd ? (
        <Suspense fallback={null}>
          {props.headerType === 'mobile' ? (
            <FreestarAd disableMargins minimumHeightEnabled={false} onlyMobile placement="top_header" />
          ) : (
            <FreestarAd disableMargins minimumHeightEnabled={false} onlyDesktop placement="top_header" />
          )}
        </Suspense>
      ) : null}
    </div>
  );
});
